import React from "react";
import { Show, SimpleShowLayout, TextField, DateField, RichTextField } from 'react-admin';

export const ProfileShow = (props) => (
	<Show {...props}>
		<SimpleShowLayout>
			<TextField source="name" />
			<TextField source="uuid" />
			<TextField source="email" />
		</SimpleShowLayout>
	</Show>
);